import * as actions from '@/modules/branchs'

export const fetchBranchs = async ({ dispatch, rootGetters }) => {
  if (rootGetters['fetching/isFetching']('branchs')) {
    return await rootGetters['fetching/getRequest']('branchs');
  }

  const request = actions.fetchBranchs();

  const response = await dispatch('fetching/doRequest', { id: 'branchs', request }, { root: true })

  response.data.forEach(data => dispatch('upsertBranch', data))

  return response;
}

export const fetchBranch = async ({ dispatch, rootGetters }, id) => {

  if (rootGetters['fetching/isFetching'](id)) {
    return await rootGetters['fetching/getRequest'](id);
  }

  const request = actions.fetchBranch(id);

  const response = await dispatch('fetching/doRequest', { id, request }, { root: true })

  dispatch('upsertBranch', response.data)

  return response;
}

export const upsertBranch = async ({ commit }, data) => {

  const { ...branch } = data;

  commit('upsertOne', branch)
}

export default {
  fetchBranchs,
  fetchBranch,
  upsertBranch
}
